import React from "react";
import useTranslations from "../hooks/useTranslations";
import { Switch, Route } from "react-router-dom";

import {
  Container,
  ScreenContainer,
  ScreenHeader,
  Button,
} from "../components/wombat-ui";
import { EditIcon } from "../components/icons";

import ViewerForm from "../components/viewer/ViewerForm";
import UpdatePasswordModalForm from "../components/viewer/UpdatePasswordModalForm";

import useViewer from "../hooks/useViewer";
import { BooleanParam, useQueryParams } from "use-query-params";
import { useBreadcrumbs } from "../hooks/useBreadcrumbs";

const ViewerProfileScreen = () => {
  const t = useTranslations();
  const viewer = useViewer();

  useBreadcrumbs([
    {
      to: "/profile",
      text: t("userProfile.title") as string,
    },
  ]);

  const [{ updatePasswordModalOpen }, setQuery] = useQueryParams({
    updatePasswordModalOpen: BooleanParam,
  });

  return (
    <ScreenContainer>
      <ScreenHeader
        title={t("userProfile.title") as string}
        description={t("userProfile.description") as string}
        icon={EditIcon}
        actions={[
          <Button
            onClick={() => setQuery({ updatePasswordModalOpen: true })}
            variant="subtle"
            key="updatePassword"
            data-test-id="updatePasswordButton"
          >
            {t("userProfile.updatePassword")}
          </Button>,
          <Button key="update" type="submit" form="userForm">
            {t("forms.actions.save")}
          </Button>,
        ]}
      />
      <Container>
        <Switch>
          <Route
            path="/"
            render={() => (
              <ViewerForm
                defaultValues={{
                  id: viewer.id,
                  email: viewer.email,
                  name: viewer.name,
                  locale: viewer.locale,
                  avatar: {
                    filename: "",
                    data: viewer.avatar || "",
                  },
                }}
              />
            )}
          />
        </Switch>
      </Container>
      <UpdatePasswordModalForm
        isOpen={updatePasswordModalOpen}
        onClose={() => setQuery({ updatePasswordModalOpen: false })}
      />
    </ScreenContainer>
  );
};

export default ViewerProfileScreen;
